export enum GEOLOCATION_ERROR_CODES {
  'PERMISSION_DENIED' = 1,
  'POSITION_UNAVAILABLE' = 2,
  'TIMEOUT' = 3,
  'UNKNOWN_ERROR' = 4,
}
